import { SITE_URL } from '@/lib/siteConfig';
import { useCanonical } from '@/lib/canonical';

/**
 * Ставит `<link rel="canonical" href="https://астрофил.рф{path}">`.
 *
 * Used at the route level (in App.js) so the canonical is present even on
 * pages that are gated by AccessGuard — i.e., when the actual page
 * component (with its own SEO meta) has not mounted yet for unauthenticated
 * crawlers. Public crawlers like Googlebot / YandexBot still see a stable,
 * normalised canonical URL pointing to the cyrillic primary domain.
 *
 * Notes:
 *   - The href intentionally omits any query string. Canonical must be the
 *     "clean" URL (utm_*, _t, etc. should never appear in canonical).
 *   - The cyrillic IRI is allowed in `href` and is what we want to surface
 *     to search engines targeting the RU market.
 *   - Тег ставится нативно (lib/canonical.js), а не через Helmet: Helmet
 *     дописывал второй canonical рядом с серверным.
 */
export default function CanonicalRf({ path }) {
  const clean = typeof path === 'string' && path
    ? (path.startsWith('/') ? path : `/${path}`)
    : null;
  useCanonical(clean ? `${SITE_URL}${clean}` : null);
  return null;
}
